import React from 'react'

import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Tooltip, CircularProgress
} from '@material-ui/core'

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount'
import { Helpers } from "dsilo-ui-components";

const RenderRowData = (props) => {
    let { rowData, keyTerm, tableHeaders, classes } = props;
    return (
        <React.Fragment>
            {tableHeaders?.map((header, index) => {
                let colValue = "";

                if (header.name === "keyTerm") {
                    colValue = keyTerm;
                } else {
                    colValue = rowData?.[header.name] || "-";
                }

                return (
                    <TableCell
                        key={index}
                        className={classes.tableCellWrapText}
                        style={{
                            padding: '0px !important',
                            borderBottom: 'none'
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Typography
                                variant="body1"
                                component="span"
                                title={colValue}
                                style={{ fontSize: "14px" }}
                            >
                                {colValue}
                            </Typography>
                        </div>
                    </TableCell>
                );
            })}
        </React.Fragment>
    );
};

export default RenderRowData;